import axios from 'axios';

const API_GET_APPLEPAY_TRANSACTION = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_API_GET_APPLEPAY_TRANSACTION}`;

export const getApplePayTransaction = (formData) => axios.post(API_GET_APPLEPAY_TRANSACTION, formData);
